/**
 * Menvora — offer countdown bar (product.ads).
 * Mobile:
 *  - Docked above RSI quantity skeletons (ads-trust block).
 *  - When the dock scrolls away, pin above floating CTA with swipe-up (no blink).
 * Desktop: always docked.
 */
(function () {
  var TZ = 'America/Mexico_City';
  var root = document.querySelector('[data-menvora-month-end]');
  var bar = document.querySelector('[data-menvora-offer-bar]');
  if (!root || !bar) return;

  var lastGap = -1;
  var pinRaf = 0;
  var expired = false;
  var mode = 'dock'; // dock | pin
  var mq = window.matchMedia('(max-width: 749px)');
  var placeholder = null;
  var enterTimer = 0;

  function tzParts(date) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(date);
    var out = {};
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type !== 'literal') out[parts[i].type] = parts[i].value;
    }
    return { y: +out.year, m: +out.month, d: +out.day };
  }

  function monthEndMs() {
    var ymd = tzParts(new Date());
    var last = new Date(Date.UTC(ymd.y, ymd.m, 0)).getUTCDate();
    var mm = String(ymd.m).padStart(2, '0');
    var dd = String(last).padStart(2, '0');
    return new Date(ymd.y + '-' + mm + '-' + dd + 'T23:59:59-06:00').getTime();
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function isMobile() {
    return mq.matches;
  }

  function dock() {
    return document.querySelector('[data-menvora-offer-bar-dock]');
  }

  function isVisibleFixed(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.position !== 'fixed') return false;
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.height > 20 && r.width > 40 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function isFloatWrapParked(wrap) {
    if (!wrap) return true;
    var r = wrap.getBoundingClientRect();
    if (r.height < 20) return true;
    var bottomPx = parseFloat(window.getComputedStyle(wrap).bottom);
    if (!isNaN(bottomPx) && bottomPx >= window.innerHeight - 12) return true;
    return false;
  }

  function isVisibleBottomBar(el) {
    if (!el || el.hidden) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.height > 20 && r.width > 40 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function floatingCta() {
    var wrap = document.getElementById('floatingBuyNowButton');
    if (wrap && !isFloatWrapParked(wrap) && isVisibleBottomBar(wrap)) return wrap;
    if (wrap && !isFloatWrapParked(wrap) && isVisibleFixed(wrap)) return wrap;

    var nodes = [
      document.querySelector('#rsi_buy_now_button.rsi_floating'),
      document.querySelector('#rsi_buy_now_button.rsi_floating_bottom'),
      document.querySelector('.rsi_floating_bottom'),
    ];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!isVisibleFixed(el) && !isVisibleBottomBar(el)) continue;
      if (el.closest && el.closest('.product__info-wrapper, .product-form')) continue;
      if (wrap && isFloatWrapParked(wrap) && wrap.contains(el)) continue;
      return el;
    }
    return null;
  }

  function bottomStackAnchor() {
    return floatingCta();
  }

  function codFormOpen() {
    if (document.body.classList.contains('menvora-cod-form-open')) return true;
    var wrap = document.getElementById('rsi_form_wrapper');
    if (!wrap) return false;
    if (wrap.hasAttribute('open')) return true;
    if (typeof wrap.open === 'boolean' && wrap.open) return true;
    var cs = window.getComputedStyle(wrap);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = wrap.getBoundingClientRect();
    // Releasit dialog: fixed/absolute OR casi viewport (detección previa fallaba)
    if (cs.position === 'fixed' || cs.position === 'absolute') {
      return r.height > window.innerHeight * 0.35;
    }
    return r.height > window.innerHeight * 0.55 && r.top < window.innerHeight * 0.2;
  }

  function ensurePlaceholder() {
    var d = dock();
    if (!d) return null;
    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.className = 'menvora-offer-bar-placeholder';
      placeholder.setAttribute('data-menvora-offer-bar-ph', '1');
      placeholder.setAttribute('aria-hidden', 'true');
      d.appendChild(placeholder);
    } else if (placeholder.parentNode !== d) {
      d.appendChild(placeholder);
    }
    return placeholder;
  }

  function setPlaceholderHeight(px) {
    var ph = ensurePlaceholder();
    if (!ph) return;
    ph.style.height = Math.max(0, Math.round(px)) + 'px';
  }

  function clearPlaceholder() {
    if (!placeholder) return;
    placeholder.style.height = '0px';
  }

  function moveBarIntoDock() {
    var d = dock();
    if (!d) return false;
    ensurePlaceholder();
    // Bar already lives inside dock in Liquid; keep it first, placeholder after.
    if (bar.parentNode !== d) {
      try {
        d.insertBefore(bar, placeholder || null);
      } catch (err) {
        try {
          d.appendChild(bar);
        } catch (e2) {}
      }
    } else if (placeholder && bar.nextElementSibling !== placeholder) {
      try {
        d.insertBefore(placeholder, bar.nextSibling);
      } catch (e3) {}
    }
    return true;
  }

  function pinToBody() {
    if (bar.parentElement === document.body) return;
    try {
      document.body.appendChild(bar);
    } catch (err) {}
  }

  function applyGap(anchor) {
    var gap = 78;
    var wrap = document.getElementById('floatingBuyNowButton');
    var measureEl = null;
    if (wrap && !isFloatWrapParked(wrap) && isVisibleBottomBar(wrap)) {
      measureEl = wrap;
    } else if (anchor) {
      measureEl = anchor;
    }
    if (measureEl) {
      // Pegado al stack sticky (sin +14): evita ver el fondo / iconos RSI en el hueco
      var measured = Math.round(window.innerHeight - measureEl.getBoundingClientRect().top);
      if (measured >= 56 && measured <= 200) gap = Math.max(0, measured - 1);
    }
    if (Math.abs(gap - lastGap) < 2) return;
    lastGap = gap;
    document.documentElement.style.setProperty('--menvora-timer-bottom', gap + 'px');
  }

  function toDock() {
    if (enterTimer) {
      window.clearTimeout(enterTimer);
      enterTimer = 0;
    }
    bar.hidden = false;
    bar.classList.remove('is-pin-visible', 'is-pin-instant', 'is-pin-enter');
    bar.classList.remove('is-pinned');
    document.body.classList.remove('menvora-offer-bar-pinned');
    moveBarIntoDock();
    clearPlaceholder();
    lastGap = -1;
    mode = 'dock';
  }

  function toPin(anchor, animate) {
    var h = bar.offsetHeight || 96;
    var wasPinned = mode === 'pin';
    setPlaceholderHeight(h);
    pinToBody();
    bar.hidden = false;
    bar.classList.add('is-pinned');
    document.body.classList.add('menvora-offer-bar-pinned');
    applyGap(anchor);

    if (animate && !wasPinned) {
      // Mismo patrón que reseñas: colocar off-screen sin transición → swipe fluido
      bar.classList.add('is-pin-instant');
      bar.classList.remove('is-pin-visible');
      void bar.offsetWidth;
      window.requestAnimationFrame(function () {
        bar.classList.remove('is-pin-instant');
        bar.classList.add('is-pin-visible');
      });
      if (enterTimer) window.clearTimeout(enterTimer);
      enterTimer = window.setTimeout(function () {
        enterTimer = 0;
      }, 400);
    } else {
      bar.classList.remove('is-pin-instant');
      bar.classList.add('is-pin-visible');
    }
    mode = 'pin';
  }

  function hideBar() {
    bar.hidden = true;
    bar.classList.remove('is-pinned', 'is-pin-visible', 'is-pin-instant', 'is-pin-enter');
    document.body.classList.remove('menvora-offer-bar-pinned');
    clearPlaceholder();
    mode = 'dock';
  }

  /**
   * Pin when the dock has left the upper viewport (scrolled past the white slot).
   * Hysteresis: pin if dock.bottom < 72; undock if dock.bottom > 120.
   */
  function shouldPinMobile() {
    var d = dock();
    if (!d) {
      return !!bottomStackAnchor();
    }
    var r = d.getBoundingClientRect();
    if (mode === 'pin') {
      return r.bottom < 120;
    }
    return r.bottom < 72;
  }

  function syncBar() {
    if (expired || codFormOpen()) {
      hideBar();
      return;
    }

    if (!isMobile()) {
      toDock();
      return;
    }

    if (shouldPinMobile()) {
      toPin(bottomStackAnchor(), true);
      return;
    }

    toDock();
  }

  function onLayout() {
    if (pinRaf) return;
    pinRaf = window.requestAnimationFrame(function () {
      pinRaf = 0;
      syncBar();
    });
  }

  var end = monthEndMs();
  var dEl = root.querySelector('[data-d]');
  var hEl = root.querySelector('[data-h]');
  var mEl = root.querySelector('[data-m]');
  var sEl = root.querySelector('[data-s]');

  window.addEventListener('scroll', onLayout, { passive: true });
  window.addEventListener('resize', onLayout);
  window.addEventListener('load', onLayout);
  window.addEventListener('menvora:cod-cta-stack-change', onLayout);
  window.addEventListener('menvora:cod-form-chrome', onLayout);
  if (mq.addEventListener) mq.addEventListener('change', onLayout);
  else mq.addListener(onLayout);

  var gallery = document.querySelector('.product--ads .product__media-wrapper');
  if (gallery && typeof ResizeObserver === 'function') {
    new ResizeObserver(onLayout).observe(gallery);
  }

  var bootPolls = 0;
  var bootPoll = window.setInterval(function () {
    syncBar();
    bootPolls += 1;
    if (bootPolls >= 24) window.clearInterval(bootPoll);
  }, 200);

  function tick() {
    var left = end - Date.now();
    if (left <= 0) {
      expired = true;
      hideBar();
      return;
    }
    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400);
    s -= d * 86400;
    var h = Math.floor(s / 3600);
    s -= h * 3600;
    var m = Math.floor(s / 60);
    s -= m * 60;
    if (dEl) dEl.textContent = String(d);
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
    window.setTimeout(tick, 1000);
  }

  // Home = dock under timeline (not above CTA)
  moveBarIntoDock();
  tick();
  syncBar();
  window.requestAnimationFrame(function () {
    syncBar();
    window.requestAnimationFrame(syncBar);
  });
})();
